<!-- Cookie Consent Banner - Non-blocking, bottom of viewport -->
@if (visible()) {
  <div
    class="cookie-consent-banner"
    role="region"
    [attr.aria-label]="'CONSENT.BANNER.ARIA_LABEL' | translate"
    [attr.aria-hidden]="!visible()"
  >
    <div class="cookie-consent-content">
      <div class="cookie-consent-text">
        <h2 class="cookie-consent-title">
          {{ 'CONSENT.BANNER.TITLE' | translate }}
        </h2>
        <p class="cookie-consent-description">
          {{ 'CONSENT.BANNER.DESCRIPTION' | translate }}
        </p>
      </div>

      <div class="cookie-consent-actions">
        <button
          mat-flat-button
          color="primary"
          (click)="acceptAnalytics()"
          [attr.aria-label]="'CONSENT.BANNER.ARIA_ACCEPT' | translate"
        >
          {{ 'CONSENT.BANNER.ACCEPT' | translate }}
        </button>

        <button
          mat-button
          class="secondary-button"
          (click)="rejectAnalytics()"
          [attr.aria-label]="'CONSENT.BANNER.ARIA_REJECT' | translate"
        >
          {{ 'CONSENT.BANNER.REJECT' | translate }}
        </button>
      </div>
    </div>
  </div>
}
